"use strict";
var isIosWebview = require("./is-ios-webview");
module.exports = function isIosUIWebview(ua, statusBarVisible) {
    statusBarVisible =
        typeof statusBarVisible !== "undefined"
            ? statusBarVisible
            : window.statusbar.visible;
    return isIosWebview(ua) && !statusBarVisible;
};
